import api from "@/api/axios/axios.js";

export async function getAllTeams() {
  const resp = await api.get("/login/teams/");
  return resp.data;
}

export async function getTeamById(teamId) {
  const resp = await api.get(`/login/teams/${teamId}/`);
  return resp.data;
}

export async function createTeam(payload) {
  const resp = await api.post("/login/teams/", payload);
  return resp.data;
}

export async function updateTeam(teamId, payload) {
  const resp = await api.put(`/login/teams/${teamId}/`, payload);
  return resp.data;
}

export async function deleteTeam(teamId) {
  const resp = await api.delete(`/login/teams/${teamId}/`);
  return resp;
}

export async function getLeaderUsers() {
  const resp = await api.get("/login/users/lider");
  return resp.data;
}

export async function getProyectos() {
  const resp = await api.get("/login/proyectos/");
  return resp.data;
}

export async function getTeamsByProyecto(clave) {
  const resp = await api.get(
    `/login/proyectos/${encodeURIComponent(clave)}/teams/`,
  );
  return resp.data;
}

// =========================
// FALTANTES PARA MIEMBROS
// =========================

export async function getTesterUsers() {
  const resp = await api.get("/login/users/tester");
  return resp.data;
}

export async function getTeamTesters(teamId) {
  const resp = await api.get(`/login/teams/${teamId}/testers/`);
  return resp.data;
}

export async function addTeamTesters(teamId, testerIds) {
  const resp = await api.post(`/login/teams/${teamId}/testers/`, {
    tester_ids: testerIds,
  });
  return resp.data;
}

export async function removeTeamTester(teamId, userId) {
  const resp = await api.delete(`/login/teams/${teamId}/testers/${userId}/`);
  return resp;
}

export async function patchTeam(teamId, payload) {
  const resp = await api.patch(`/login/teams/${teamId}/`, payload);
  return resp.data;
}

export async function assignTeamsToProject(projectKey, teamIds) {
  const resp = await api.post(
    `/login/proyectos/${encodeURIComponent(projectKey)}/teams/`,
    { team_ids: teamIds },
  );
  return resp.data;  
}

export async function removeTeamFromProject(projectKey, teamId) {
  const resp = await api.delete(
    `/login/proyectos/${encodeURIComponent(projectKey)}/teams/${teamId}/`,
  );
  return resp;
}